const ORDER_QUANTITY_DECIMAL_PLACES = 2;

export function normalizeOrderQuantity(quantity: number): number {
  return Number((Number(quantity) || 0).toFixed(ORDER_QUANTITY_DECIMAL_PLACES));
}
